export enum CustomHttpStatuses {
  integrationApiError = 527,
}
